import { getKeyValidationErrors } from './validation.js';

const requiredEncryptedDataKeys = {
  id: true,
  data: true,
  encrypted: true,
  keyVersion: true,
  timestamp: true
};
/**
 * Determine whether an object of type Partial<EncryptedData> meets
 * all requirements to be non-partial
 */

const isEncryptedDataValid = encryptedData => !getKeyValidationErrors(encryptedData, requiredEncryptedDataKeys);

export { isEncryptedDataValid };
